import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { 
  Users, 
  Settings, 
  LogOut, 
  Home,
  BarChart3,
  Shield,
  FolderOpen
} from "lucide-react"
import { removeAuthToken } from "../config/api"

function Admin() {
  const navigate = useNavigate()

  const handleLogout = () => {
    removeAuthToken()
    navigate('/admin/login')
  }

  const adminMenuItems = [
    {
      title: "Kullanıcı Yönetimi",
      icon: Users,
      description: "Kullanıcıları görüntüle, düzenle ve yönet",
      href: "/admin/users",
      color: "bg-blue-500"
    },
    {
      title: "Hizmet Yönetimi",
      icon: Settings,
      description: "Hizmetleri görüntüle, düzenle ve yönet",
      href: "/admin/services",
      color: "bg-green-500"
    },
    {
      title: "Proje Yönetimi",
      icon: FolderOpen,
      description: "Projeleri görüntüle, düzenle ve yönet",
      href: "/admin/projects",
      color: "bg-purple-500"
    },
    {
      title: "İstatistikler",
      icon: BarChart3,
      description: "Site istatistiklerini görüntüle ve düzenle",
      href: "/admin/stats",
      color: "bg-red-500"
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-4">
              <Shield className="h-8 w-8 text-blue-600" />
              <div>
                <h1 className="text-xl font-bold text-gray-900">Admin Paneli</h1>
                <p className="text-sm text-gray-500">Buğra Teknik Servis</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <a
                href="/"
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <Home className="h-5 w-5" />
                <span>Siteyi Görüntüle</span>
              </a>
              
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 text-red-600 hover:text-red-700 transition-colors"
              >
                <LogOut className="h-5 w-5" />
                <span>Çıkış Yap</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Hoş Geldiniz</h2>
          <p className="text-gray-600">Site içeriğini yönetmek için aşağıdaki seçeneklerden birini kullanın.</p>
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {adminMenuItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => navigate(item.href)}
            >
              <div className="p-6">
                <div className="flex items-center space-x-4">
                  <div className={`p-3 rounded-lg ${item.color}`}>
                    <item.icon className="h-6 w-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      
      </main>
    </div>
  )
}

export default Admin 